import { useState } from "react";
import { X } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { updateProductPageState } from "../../../Pages/Product/productActions";
import { updateVideoPageState } from "../../../Pages/Video/VideoActions";
import { submitUnFlaggedVideo, trashItem } from "../../SharedActions";
import "./FlaggedModal.scss";

export default () => {
  const [loading, setLoading] = useState(false);

  const trshItemId = useSelector((state) => state.productPageStates.itemId);
  const moveToTrashModal = useSelector(
    (state) => state.productPageStates.moveToTrashModal
  );
  const movedToTrash = useSelector(
    (state) => state.productPageStates.movedToTrash
  );

  const dispatch = useDispatch();

  const sumbit = () => {
    setLoading(true);
    trashItem(`products/${trshItemId}/trash_product`)
      .then((response) => {
        if (response) {
          setLoading(false);
          dispatch(
            updateProductPageState({
              movedToTrash: true,
            })
          );
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Modal
      size="sm"
      style={{ maxWidth: "510px" }}
      isOpen={moveToTrashModal}
      className="ConfirmUnflag modal-dialog-centered"
    >
      <ModalHeader className="justify-content-end">
        <X
          size={30}
          role="button"
          className="closeBtn"
          onClick={() => {
            dispatch(
              updateProductPageState({
                moveToTrashModal: false,
                movedToTrash: false,
                itemId: "",
              })
            );
          }}
        />
      </ModalHeader>
      <ModalBody className="p-0">
        {!movedToTrash ? (
          <>
            <div className="d-flex justify-content-center">
              <div
                className="text-center"
                style={{ width: "275px", height: "131px" }}
              >
                <div className="mb-2">
                  <h2 style={{ lineHeight: "44px", color: "black" }}>
                    Are you sure you want to delete this product?
                  </h2>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-between">
              <Button
                className="video-process-btn"
                size="lg"
                color="outline-primary"
                onClick={() => {
                  dispatch(
                    updateProductPageState({
                      moveToTrashModal: false,
                      movedToTrash: false,
                      itemId: "",
                    })
                  );
                }}
              >
                No
              </Button>
              <Button
                className="video-process-btn"
                size="lg"
                color="primary"
                onClick={sumbit}
                disabled={loading}
              >
                Yes
              </Button>
            </div>
          </>
        ) : (
          <>
            <div className="d-flex justify-content-center">
              <div className="">
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <img
                    src={
                      require(`@src/assets/images/vyrill/trash-icon.png`)
                        .default
                    }
                    width={40}
                    alt=""
                  />
                </div>
                <div className="d-flex justify-content-center">
                  <h2
                    style={{
                      marginTop: "42px",
                      lineHeight: "44px",
                      color: "black",
                      width: "64%",
                      textAlign: "center",
                    }}
                  >
                    Your product has been moved to trash
                  </h2>
                </div>
              </div>
            </div>
          </>
        )}
      </ModalBody>
    </Modal>
  );
};
